import { c as _c } from "react/compiler-runtime";
import { IcoTrash16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
type PreviewSelectableProps = {
  children: ReactNode;
  isSelected: boolean;
  onSelect: () => void;
  /** Names a part whose own content is inert, so it can't name the control itself. */
  label?: string;
  /** Absent when the part can't be removed, which drops the control. */
  remove?: {
    label: string;
    onRemove: () => void;
  };
  /** The header gets more room around it than a button does. */
  wide?: boolean;
};

/**
 * Custom data's `QuestionContainer` box in its `flush` form: the border sits just outside the part,
 * so the preview keeps the runtime's spacing.
 */
export const PreviewSelectable = t0 => {
  const $ = _c(19);
  const {
    children,
    isSelected,
    onSelect,
    label,
    remove,
    wide: t1
  } = t0;
  const wide = t1 === undefined ? false : t1;
  const t2 = !wide;
  const t3 = !isSelected;
  let t4;
  if ($[0] !== isSelected || $[1] !== t2 || $[2] !== t3 || $[3] !== wide) {
    t4 = cx("absolute pointer-events-none rounded border-2 transition-colors", {
      "-inset-x-3 -inset-y-2": wide,
      "-inset-1": t2,
      "border-accent bg-accent/8": isSelected,
      "border-transparent group-hover:border-tertiary": t3
    });
    $[0] = isSelected;
    $[1] = t2;
    $[2] = t3;
    $[3] = wide;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <span aria-hidden={true} className={t4} />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== children || $[8] !== isSelected || $[9] !== label || $[10] !== onSelect || $[11] !== t5) {
    t6 = <button type="button" aria-label={label} aria-pressed={isSelected} onClick={onSelect} className="flex flex-col w-full text-left cursor-pointer">{t5}{children}</button>;
    $[7] = children;
    $[8] = isSelected;
    $[9] = label;
    $[10] = onSelect;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isSelected || $[14] !== remove) {
    t7 = remove && <div className={cx("absolute z-10 top-1/2 -translate-y-1/2 right-3 flex items-center opacity-0 group-hover:opacity-100 transition-opacity", "backdrop-blur-sm bg-primary/80 rounded border border-tertiary px-1 py-0.5", {
      "max-md:opacity-100": isSelected,
      "max-md:pointer-events-none": !isSelected
    })}><IconButton onClick={remove.onRemove} icon={IcoTrash16} aria-label={remove.label} className="size-4 max-md:size-8" tabIndex={-1} variant="ghost" size="tiny" destructive={true} /></div>;
    $[13] = isSelected;
    $[14] = remove;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="relative group">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};